import { getValue } from "../../utils/object.utils";

export const transformSubjectListTableData = (
  subjectList: Array<any>
): any[] => {
  const transformDatForTable = subjectList.map((subject: any): any => {
    const subjectDetails = getValue(subject, "subject_details", []);
    const fullMarksSummary = (subjectDetails || [])
      .map((detail: any) => {
        const className = getValue(detail, "class.name", "Class");
        const marks = getValue(detail, "subject_marks");
        if (marks === null || marks === undefined) {
          return `${className}: -`;
        }
        return `${className}: ${marks}`;
      })
      .join(", ");

    return {
      id: subject.id,
      name: getValue(subject, "name", ""),
      subject_type: getValue(subject, "subject_type", ""),
      subject_type_title: getValue(subject, "subject_type_title", ""),
      subject_details: subjectDetails,
      full_marks_summary: fullMarksSummary || "-",
    };
  });
  return transformDatForTable;
};
